<template>
  <v-form @submit.prevent="setCutOffSettings" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Cut Off Settings</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" class="error">{{errorMessage}}</p>
        <v-card-text >
          <v-alert :value="true" color="warning" icon="warning" outline style="margin: 10px 20px 10px 20px;">
              <b>Note</b>, once saved you will not be able to change this settings for security purposes. Please contact support for assistance.
          </v-alert>
            <v-layout row wrap style="padding: 10px 20px 10px 20px;">
              <v-flex xs12 sm12 >
                <v-select
                    label="Cut Off Type"
                    :items="cutoff_types"
                    :rules="[rules.required]" 
                    item-text="description"
                    item-value="type"
                    :disabled="disabled"
                    v-model="type"        
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 >
                <v-select
                    label="Tax Table Type"
                    :items="tax_table_types"
                    :rules="[rules.required]" 
                    :disabled="disabled"
                    v-model="taxTableType"   
                ></v-select>
              </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="error" :loading="loading" style="color:white">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
    import cutoffApi from '@/api/cutoff'

    export default {
    name: 'login-dialog',
    data () {
      return {
        loading: false,
        disabled: false,     
        error: false,
        errorMessage: null,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
        },
        cutoff_types: [],
        tax_table_types: ['SEMI-MONTHLY', 'MONTHLY', 'ANNUAL'], //fixed data
        type: null,
        taxTableType: null
      }
    },
    methods: {
      closeDialog() {
        this.$emit('update:dialogSet', false)
        this.clearForm()
      },
      async setCutOffSettings() {
        if (this.$refs.form.validate()) {
          try {
                this.loading = true
                this.disabled = true
                
                var data = {
                    type: this.type,
                    taxTableType: this.taxTableType
                }
                await cutoffApi.updateSettings(data)

                this.closeDialog()

                this.loading = false
                this.disabled = false

                this.$emit('send', '')
          }catch(error) {
              this.errorMessage = error
              this.error = true
          }
        }
      },
      async getCutOffTypes() {
        try {
          const response = await cutoffApi.getTypes()
          if (response.status == 200) {
            this.cutoff_types = response.data.items
          }
        }catch(error){
          this.error = true
          this.errorMessage = error
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.loading = false
        this.error = false
      },
    },
    computed: {},
    created() {
      this.getCutOffTypes()
    }
  }
</script>